// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
  border-radius: 10px;
  border: 3px solid transparent;
  overflow: hidden;
}
.container.locked img {
  opacity: 0.7;
}
.container.unlockable {
  cursor: pointer;
}
.container.unlockable img {
  opacity: 0.7;
}
.container.available {
  cursor: pointer;
}
.container.available img {
  opacity: 0.85;
}
.container.selected {
  border-color: #D3D800;
}
.container.selected img {
  opacity: 1;
}
.container img {
  background: white;
}
.container > .locked {
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 6px;
}
.container > .locked > .btn {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 36px;
  width: 36px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}
.container > .locked > .btn.locked-icon {
  background: #DADADA;
}
.container > .locked > .btn.locked-icon mat-icon {
  min-height: unset;
  min-width: unset;
  height: 18px;
  width: 18px;
  font-size: 18px;
}
.container > .locked > .btn.unlock {
  background: rgba(36, 183, 199, 0.9);
  color: #fff;
  line-height: 2px;
}
.container > .locked > .btn.unlock mat-icon {
  min-height: unset;
  min-width: unset;
  height: 14px;
  width: 14px;
}
.container > .unlocked {
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  align-items: flex-end;
  justify-content: flex-end;
}
.container > .unlocked > .avatar-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 58px;
  width: 58px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid #EC6602;
  position: relative;
}
.container > .unlocked > .avatar-icon > .avatar-default {
  display: none;
}
.container > .unlocked > .avatar-icon.selected {
  background: rgba(236, 102, 2, 0.8);
  border: none;
}
.container > .unlocked > .avatar-icon.selected > .avatar-default {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  width: 24px;
  height: 24px;
}
.container > .unlocked > .avatar-icon.locked-icon {
  background: #DADADA;
}
.container > .unlocked > .avatar-icon.unlock {
  background: rgba(36, 183, 199, 0.9);
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/gamification/core/accessory-thumbnail/accessory-thumbnail.component.scss","webpack://./../APP%20Humanum/src/app/@modules/gamification/core/accessory-thumbnail/accessory-thumbnail.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,gBAAA;ACAJ;ADGQ;EACI,YAAA;ACDZ;ADMI;EACI,eAAA;ACJR;ADMQ;EACI,YAAA;ACJZ;ADQI;EACI,eAAA;ACNR;ADQQ;EACI,aAAA;ACNZ;ADUI;EACI,qBAAA;ACRR;ADUQ;EACI,UAAA;ACRZ;ADcI;EACI,iBAAA;ACZR;ADeI;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EAEA,yBAAA;EACA,uBAAA;EACA,YAAA;ACdR;ADgBQ;EACI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;ACdZ;ADgBY;EACI,mBAAA;ACdhB;ADgBgB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;ACdpB;ADkBY;EACI,mCAAA;EACA,WAAA;EACA,gBAAA;AChBhB;ADkBgB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AChBpB;ADuBI;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,qBAAA;EACA,yBAAA;ACrBR;ADuBQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iDAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;ACrBZ;ADuBY;EACI,aAAA;ACrBhB;ADwBY;EACI,kCAAA;EACA,YAAA;ACtBhB;ADwBgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;ACtBpB;AD0BY;EACI,mBAAA;ACxBhB;AD2BY;EACI,mCAAA;EACA,WAAA;ACzBhB","sourcesContent":[".container {\n    position: relative;\n\n    border-radius: 10px;\n    border: 3px solid transparent;\n    overflow: hidden;\n\n    &.locked {\n        img {\n            opacity: 0.70;\n        }\n    }\n\n\n    &.unlockable {\n        cursor: pointer;\n\n        img {\n            opacity: 0.70;\n        }\n    }\n\n    &.available {\n        cursor: pointer;\n\n        img {\n            opacity: 0.85;\n        }\n    }\n\n    &.selected {\n        border-color: #D3D800;\n\n        img {\n            opacity: 1;\n        }\n    }\n\n\n\n    img {\n        background: white;\n    }\n\n    >.locked {\n        display: flex;\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n\n        justify-content: flex-end;\n        align-items: flex-start;\n        padding: 6px;\n\n        >.btn {\n            display: flex;\n            flex-flow: column;\n            justify-content: center;\n            align-items: center;\n            height: 36px;\n            width: 36px;\n            font-size: 12px;\n            font-weight: 600;\n            border-radius: 50%;\n            box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n\n            &.locked-icon {\n                background: #DADADA;\n\n                mat-icon {\n                    min-height: unset;\n                    min-width: unset;\n                    height: 18px;\n                    width: 18px;\n                    font-size: 18px;\n                }\n            }\n\n            &.unlock {\n                background: rgba(36, 183, 199, 0.9);\n                color: #fff;\n                line-height: 2px;\n\n                mat-icon {\n                    min-height: unset;\n                    min-width: unset;\n                    height: 14px;\n                    width: 14px;\n                }\n            }\n        }\n\n    }\n\n    >.unlocked {\n        display: flex;\n        position: absolute;\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        align-items: flex-end;\n        justify-content: flex-end;\n\n        >.avatar-icon {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 58px;\n            width: 58px;\n            border-radius: 50%;\n            box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\n            background: rgba(255, 255, 255, 0.5);\n            border: 2px solid #EC6602;\n            position: relative;\n\n            >.avatar-default {\n                display: none;\n            }\n\n            &.selected {\n                background: rgba(236, 102, 2, 0.8);\n                border: none;\n\n                >.avatar-default {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    position: absolute;\n                    top: -6px;\n                    right: -6px;\n                    border-radius: 50%;\n                    background: rgba(255, 255, 255, 0.9);\n                    width: 24px;\n                    height: 24px;\n                }\n            }\n\n            &.locked-icon {\n                background: #DADADA;\n            }\n\n            &.unlock {\n                background: rgba(36, 183, 199, 0.9);\n                color: #fff;\n            }\n        }\n\n    }\n}",".container {\n  position: relative;\n  border-radius: 10px;\n  border: 3px solid transparent;\n  overflow: hidden;\n}\n.container.locked img {\n  opacity: 0.7;\n}\n.container.unlockable {\n  cursor: pointer;\n}\n.container.unlockable img {\n  opacity: 0.7;\n}\n.container.available {\n  cursor: pointer;\n}\n.container.available img {\n  opacity: 0.85;\n}\n.container.selected {\n  border-color: #D3D800;\n}\n.container.selected img {\n  opacity: 1;\n}\n.container img {\n  background: white;\n}\n.container > .locked {\n  display: flex;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  justify-content: flex-end;\n  align-items: flex-start;\n  padding: 6px;\n}\n.container > .locked > .btn {\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  height: 36px;\n  width: 36px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 50%;\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n}\n.container > .locked > .btn.locked-icon {\n  background: #DADADA;\n}\n.container > .locked > .btn.locked-icon mat-icon {\n  min-height: unset;\n  min-width: unset;\n  height: 18px;\n  width: 18px;\n  font-size: 18px;\n}\n.container > .locked > .btn.unlock {\n  background: rgba(36, 183, 199, 0.9);\n  color: #fff;\n  line-height: 2px;\n}\n.container > .locked > .btn.unlock mat-icon {\n  min-height: unset;\n  min-width: unset;\n  height: 14px;\n  width: 14px;\n}\n.container > .unlocked {\n  display: flex;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n.container > .unlocked > .avatar-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 58px;\n  width: 58px;\n  border-radius: 50%;\n  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\n  background: rgba(255, 255, 255, 0.5);\n  border: 2px solid #EC6602;\n  position: relative;\n}\n.container > .unlocked > .avatar-icon > .avatar-default {\n  display: none;\n}\n.container > .unlocked > .avatar-icon.selected {\n  background: rgba(236, 102, 2, 0.8);\n  border: none;\n}\n.container > .unlocked > .avatar-icon.selected > .avatar-default {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  width: 24px;\n  height: 24px;\n}\n.container > .unlocked > .avatar-icon.locked-icon {\n  background: #DADADA;\n}\n.container > .unlocked > .avatar-icon.unlock {\n  background: rgba(36, 183, 199, 0.9);\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
